export function deduplicateById(items, keyField = 'id') {
  if (!Array.isArray(items)) return items;
  
  const seen = new Set();
  return items.filter(item => {
    if (!item || !item[keyField]) return false;
    
    const key = item[keyField];
    if (seen.has(key)) return false;
    
    seen.add(key);
    return true;
  });
}

export function validateMediaItems(items) {
  if (!Array.isArray(items)) return [];
  
  return items.filter(item => {
    if (!item || !item.id) return false;
    if (!item.title && !item.name) return false;
    if (typeof item.id !== 'number' || item.id <= 0) return false;
    
    return true;
  });
}

export function createStableKey(item, prefix = '', index = null) {
  if (!item) return `${prefix}invalid-${index || 0}`;
  
  if (item.id) {
    const mediaType = item.media_type || 'unknown';
    return prefix ? `${prefix}-${mediaType}-${item.id}` : `${mediaType}-${item.id}`;
  }
  
  const title = item.title || item.name || 'unknown';
  const year = item.release_date || item.first_air_date || 'unknown';
  const mediaType = item.media_type || 'unknown';
  
  const fallbackKey = `${mediaType}-${title.replace(/\s+/g, '-').toLowerCase()}-${year}`;
  
  if (index !== null) {
    return prefix ? `${prefix}-${fallbackKey}-${index}` : `${fallbackKey}-${index}`;
  }
  
  return prefix ? `${prefix}-${fallbackKey}` : fallbackKey;
} 